import { Attachment } from '../../_models/attachment.model';

export class AttachmentVieverFile {
  fileType: string;
  url: any;
}